import { Component, Output, EventEmitter, Input, ViewChild, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ModalDirective } from "../../directives/modal.directive";
import { AppSettings } from "../../appsettings";

@Component({
    selector: "confirmationmodal",
    templateUrl: "./confirmationmodal.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ModalDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ConfirmationModalComponent {
    @Output() onAccept = new EventEmitter();
    @Output() onDecline = new EventEmitter();
    @Input() confirmationText: string = "";
    loaded: boolean = false;
    config: any = {};
    @ViewChild("confirmationModal") public confirmationModal: ModalDirective;

    constructor() {
        if (this.confirmationText === "") {
            this.confirmationText = AppSettings.pendingChangeText;
        }
    }

    /**
     * Emits the change to the caller and closes the modal
     */
    onClick(accept: boolean): void {
        if (accept) {
            this.onAccept.emit();
        } else {
            this.onDecline.emit();
        }
        this.confirmationModal.hide();
    }

    openModal(): void {
        this.confirmationModal.show();
    }
    closeModal(): void {
        this.confirmationModal.hide();
    }
}

